import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import IconsMixin from '@/mixins/IconsMixin';
import ProductMixin from '@/mixins/ProductMixin';
import {
    ProductServiceItem,
    SelectedServiceProduct,
    Product,
    FieldName, ProductType
} from '../ProductsAndServicesModels';
import ContentCard from "@/products-and-services/products-type/ContentCard.vue";
import BigNumber from 'bignumber.js';

@Component({
    components: {
        ContentCard,
    },
})
export default class StreamingDevices extends Mixins(IconsMixin, ProductMixin) {
    @Prop({type: Array, required: false})
    private products!: Product[];
    @Prop({type: String, required: false})
    private serviceTypeId!: string;
    @Prop({type: String, required: false})
    private serviceId!: string;
    @Prop({type: String, required: false})
    private serviceCatId!: string;
    @Prop({type: Boolean, required: false, default: false})
    private isFullCart!: boolean;

    @Watch("products")
    checkProducts() {
        this.setValues();
    }

    private selectedValue?: any = {};
    private selectedProduct: Product = {} as Product;

    get streamingDevice(): Product {
       return this.products.filter(x => x.typeId === ProductType.STREAMING_DEVICES && x.isSelected)[0];
    }

    get streamingDevices(): Product[] {
        return this.products.sort( (a: Product, b:Product) => {
            const first = (a.name) ? a.name.replace(/^\D+/g, '') : '';
            const second = (b.name) ? b.name.replace(/^\D+/g, '') : '';
            return parseInt(first, 10) > parseInt(second,10) ? 1 : -1
        });
    }

    get inCart() {
        return this.isInCart(this.getSelectedProduct());
    }

    getSelectedProduct(): SelectedServiceProduct {
        return this.getSelectedServiceProduct(this.selectedProduct);
    }

    getSelectedDisplayedProduct(): ProductServiceItem {
        const {serviceId, serviceTypeId, serviceCatId, productId, productCatId, imageUrl, learnMoreUrl} = this.getSelectedServiceProduct(this.selectedProduct);
        return {
            index: 0,
            serviceId,
            serviceTypeId,
            serviceCatId,
            productId,
            productCatId,
            name: "Streaming Devices",
            description: "You must have one streaming device for each TV.",
            totalAmount: -99999.00,
            imageUrl: imageUrl,
            learnMoreUrl: learnMoreUrl
        };
    }

    getSelectedServiceProduct(product: Product) {
        const {productId, productCatId, imageUrl, learnMoreUrl} = product;
        const {serviceTypeId, serviceId, serviceCatId} = this;
        return {serviceId, serviceTypeId, serviceCatId, productId, productCatId, imageUrl, learnMoreUrl}
    }

    async save(product: Product) {
        this.selectedProduct = product;
        for (const option of this.streamingDevices) {
            await this.removeFromCart({...this.getSelectedServiceProduct(option), noRefetch: true });
        }
        await this.addToCart({ ...this.getSelectedServiceProduct(product), noRefetch: false });
    }

    setValues() {
        const selectedAmount = this.products.filter(p => p.isSelected);
        if (selectedAmount[0]) {
            this.selectedValue = selectedAmount[0].catId;
        } else {
            this.selectedValue = {};
        }
    }

    created() {
        const selectedProduct = this.products.filter(product => product.isSelected);
        const starterProduct = this.products.filter(product => product.amount === '0.00');
        if (selectedProduct.length > 0) {
            this.selectedProduct = selectedProduct[0];
        } else {
            this.selectedProduct = starterProduct[0];
        }
        this.setValues();
    }
}
